<template>
  <div class="h-empty">
    <div
      :is="component"
      :breakpoint="size === 'fit' ? breakpoint : null"
      :class="{
        [`h-breakpoint--${size}`]: size !== 'fit',
        'has-title': hasTitle || title,
        'has-description': hasDescription || description
      }"
      class="h-empty__wrapper"
    >
      <template v-if="hasDefault">
        <slot />
      </template>
      <template v-else>
        <slot v-if="hasImg" name="img" />
        <img v-else-if="img" :src="img" alt="" />
        <h-empty-no-data v-else />
        <p
          v-if="hasTitle && (type === 'md' || type === 'lg')"
          class="h-empty__title"
        >
          <slot name="title" />
        </p>
        <p v-else-if="title" class="h-empty__title" v-text="title" />
        <p v-if="hasDescription" class="h-empty__description">
          <slot name="description" />
        </p>
        <p
          v-else-if="description"
          class="h-empty__description"
          v-text="description"
        />
        <p
          v-if="isNone"
          class="h-empty__description"
          v-text="t('h.empty.noData')"
        />
      </template>
    </div>
  </div>
</template>
<script>
import { t } from '@hui-pro/locale';

export default {
  name: 'HEmpty',
  props: {
    size: {
      type: String,
      default: 'md',
      validator(value) {
        return ['xs', 'sm', 'md', 'lg', 'fit', 'custom'].includes(value);
      }
    },
    img: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    breakpoint: {
      type: Object,
      default: () => {
        return {
          xs: {
            width: 180,
            height: 180
          },
          sm: {
            width: 240,
            height: 240
          },
          md: {
            width: 256,
            height: 400
          },
          lg: {
            width: 1080,
            height: 400
          },
          xl: {
            width: 1920,
            height: 554
          }
        };
      }
    }
  },
  data: function() {
    return {
      t,
      type: 'md',
      component: 'div'
    };
  },
  computed: {
    hasDefault() {
      return this.$slots.default;
    },
    hasImg() {
      return this.$slots.img;
    },
    hasTitle() {
      return this.$slots.title;
    },
    hasDescription() {
      return this.$slots.description;
    },
    isNone() {
      return (
        !this.hasDefault &&
        !this.hasImg &&
        !this.hasTitle &&
        !this.hasDescription &&
        !this.title &&
        !this.description
      );
    }
  },
  watch: {
    size: {
      immediate: true,
      handler(val) {
        this.type = val;
        if (val === 'fit') {
          this.component = 'h-breakpoint';
        } else {
          this.component = 'div';
        }
      }
    }
  }
};
</script>
